import React from 'react';

const SelectField = ({
  field = {},
  className = '',
  forceError,
  id,
  form: { submitCount, errors = {}, values = {}, touched = {} },
  children,
  ...props
}) => {
  const isFormSubmitted = !!submitCount;
  const hasAttemptedInput = !!values[field.name] && touched[field.name];
  const shouldShowError =
    (isFormSubmitted || hasAttemptedInput) && errors[field.name];
  const shouldShowErrorHighlight = shouldShowError || forceError;
  const errorMessageId = `error_${id}`;

  return (
    <>
      <select
        id={id}
        aria-invalid={!!shouldShowError}
        aria-describedby={errorMessageId}
        className={`${className} ${shouldShowErrorHighlight ? 'error' : ''}`}
        {...field}
        {...props}
      >
        {children}
      </select>
      {shouldShowError && (
        <span className="form-control__error" role="alert">
          {errors[field.name]}
        </span>
      )}
    </>
  );
};

export default SelectField;
